<template>
  <Can action="view" subject="invoice">
    <div data-component-group="invoice-dialog" data-component="edit">
      <dialog-edit
        icon="event"
        :to="`/invoices/${activeInvoice?.id}`"
        :title="activeInvoice.invoice_number"
        content-class="edit-invoice-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-invoice-edit
            :invoice="activeInvoice"
            :on-cancel="onCancel"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    created() {
      if (!this.activeInvoice?.id) {
        this.$store.dispatch('invoices/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeInvoice() {
        return this.$store.getters['invoices/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'invoices' });
      },
    },
  };
</script>
